// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__7xgmm","option":"styles_option__Lfz5p","active":"styles_active__OZ+cb"};